import React from "react";
import {
    ProgressRoot,
    ProgressTrack,
    ProgressIndicator,
    ProgressValue,
} from "@design-system/ProgressBar/ProgressBar";
import { BulkActionsToastData } from "@components/transactions/TransactionsBulkActions/lib/bulkActions";

type Props = BulkActionsToastData;
export const ToastUpdating: React.FC<Props> = ({
    updateDetails,
    updateProgress,
}) => {
    const total = updateDetails.transactionsCount;
    const processed = Math.min(
        updateDetails.transactionsCount,
        updateProgress ?? 0,
    );
    const progress = total > 0 ? Math.floor((100 * processed) / total) : 0;

    return (
        <div className="transactions-update-toast__content">
            <p className="transactions-update-toast__label">
                Updating transactions…
            </p>
            <section className="transactions-update-toast__progress">
                <ProgressRoot value={progress}>
                    <ProgressTrack>
                        <ProgressIndicator />
                    </ProgressTrack>
                    <ProgressValue />
                </ProgressRoot>
            </section>
        </div>
    );
};
